module.exports = __webpack_public_path__ + "static/drow_rogue-508aa654774995c520b3b111a894f954.png";